<div class="container product-section">
  <h1 class="main-title">{{ title }}</h1>

  <!-- Uncomment if tabs are used -->
  <!--
  <div class="tabs d-flex justify-content-center flex-wrap gap-2">
    <button class="btn custom-tab"
            [ngClass]="{ active: selectedTab === 'all' }"
            (click)="selectTab('all')">
      {{ 'PRODUCT_SECTION.ALL' | translate }}
    </button>
    <button class="btn custom-tab"
            [ngClass]="{ active: selectedTab === 'new' }"
            (click)="selectTab('new')">
      {{ 'PRODUCT_SECTION.NEW' | translate }}
    </button>
    <button class="btn custom-tab"
            [ngClass]="{ active: selectedTab === 'featured' }"
            (click)="selectTab('featured')">
      {{ 'PRODUCT_SECTION.FEATURED' | translate }}
    </button>
    <button class="btn custom-tab"
            [ngClass]="{ active: selectedTab === 'onsale' }"
            (click)="selectTab('onsale')">
      {{ 'PRODUCT_SECTION.ON_SALE' | translate }}
    </button>
  </div>
  -->

  <div class="row g-4">
    <div class="col-6 col-sm-4 col-md-3 col-lg-2" *ngFor="let item of productList">
      <div (click)="ViewProduct(item.id)" class="cursor-pointer h-100">
        <app-product-card [data]="item"></app-product-card>
      </div>
    </div>
  </div>

  <div class="text-center mt-5">
    <button class="btn all-button" [routerLink]="['/products']">
      {{ 'PRODUCT_SECTION.ALL_PRODUCTS' | translate }}
    </button>
  </div>
</div>